/**
 * Copyright 2020 AutoZone, Inc.
 * Content is confidential to and proprietary information of AutoZone, Inc., its
 * subsidiaries and affiliates.
 */
import React from 'react';
import cx from 'classnames';
import styles from './styles.module.scss';
import { useLegacyRouter } from '@/hooks/useLegacyRouter';
import { routePaths } from '@/constants/routePaths';
import { formatPrice } from '@/utils/validator/formatPrice';
import { getSafeNumber } from '@/utils/common';
import { DiscountDisplay } from './DiscountDisplay';

type Props = {
  price: number | string;
  wasPrice: number | string;
  alignRight?: boolean;
  quantity?: number;
};

export const StrikeThroughPriceWrapper = ({
  price,
  wasPrice,
  quantity = 1,
  alignRight = false,
}: Props) => {
  const router = useLegacyRouter();
  const isCartPage = router.asPath.includes(routePaths.cart);

  const itemPrice = getSafeNumber(wasPrice);
  const itemDiscountedPrice = getSafeNumber(price);

  if (itemDiscountedPrice === 0) {
    return null;
  }

  return itemPrice > itemDiscountedPrice ? (
    <>
      <div
        className={cx(
          alignRight ? styles.discountSectionWCorePrice : styles.discountSection,
          isCartPage ? styles.cart : styles.products,
        )}
        data-m-id={`strikeThroughContainer${isCartPage ? 'Cart' : 'Product'}`}
      >
        {!isCartPage ? (
          <DiscountDisplay
            price={price}
            wasPrice={wasPrice}
            quantity={quantity}
            isCartPage={isCartPage}
          />
        ) : null}

        <p className={alignRight ? styles.alignRightStrikethrough : styles.strikeprice}>
          <span className="sr-only">was </span>
          <span data-m-id="strikeThroughPrice">{`$${formatPrice(itemPrice)}`}</span>
        </p>
      </div>
    </>
  ) : null;
};

export default StrikeThroughPriceWrapper;
